import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaisesService {

  constructor(private http: HttpClient) { }

  getPaises(): Observable<any> {
    const urlGet = 'https://restcountries.eu/rest/v2/all';
    return this.http.get<any[]>(urlGet);
  }
}
